import React from "react";
import Draggable from "react-draggable";

import {
  IgTooltip,
  IgTypography,
  VariationColors,
} from "@intelligems/ig-theme";
import { RounderObject } from "@intelligems/ig-utils";
import { Box } from "@mui/material";

interface GroupSliderElementProps {
  addHandle: boolean;
  onSlide: (
    movementData: any,
    groupIndex: number,
    groups: RounderObject[]
  ) => void;
  width: number;
  object: RounderObject;
  objects: RounderObject[];
  showPercent?: boolean;
  small?: boolean;
}

export const GroupSliderElement = ({
  addHandle,
  onSlide,
  width,
  object,
  objects,
  showPercent,
  small,
}: GroupSliderElementProps) => {
  const onRightEdge = objects
    .slice(object.order)
    .every(({ percentage }) => percentage === 0);

  const onLeftEdge = objects
    .slice(0, object.order)
    .every(({ percentage }) => percentage === 0);

  const zIndex =
    1 +
    (onRightEdge ? Math.abs(objects.length - object.order) : 0) +
    (onLeftEdge ? object.order : 0);

  // Adding a <Root> here breaks react-draggable... had to use sx inline styles rather than a styled div
  return (
    <>
      {addHandle && (
        <Draggable
          grid={[10, 10]} // every "tick" of the slider left/right is 10px, or 1% of the sliders width
          onDrag={(e, data) => {
            if (e) {
              // console.log("e", e);
            }
            onSlide(data, object.order, objects);
          }}
          // setting axis to none and position to 0,0 stops the slider from sliding faster than
          // the colors/sliderVariants are sliding
          axis="none"
          position={{ x: 0, y: 0 }}
        >
          <Box
            className="MuiSlider-valueLabelCircle"
            sx={{
              width: "0px",
              margin: "auto",
            }}
            style={{ zIndex: zIndex }}
          >
            <Box
              sx={{
                left: "-15px",
                top: small ? "-21px" : "-18px",
                cursor: "grab",
                width: small ? "17px" : "27px",
                height: small ? "17px" : "27px",
                zIndex: 1,
                position: "relative",
                borderRadius: "100%",
                backgroundColor:
                  VariationColors[object.order - 1] || VariationColors[0],
                boxShadow: "0px 2px 3px rgb(0 0 0 / 10%)",
                "&:active": {
                  cursor: "grabbing",
                },
              }}
            />
          </Box>
        </Draggable>
      )}
      <Box
        sx={{
          position: "relative",
          backgroundColor: VariationColors[object.order] || VariationColors[0],
          height: small ? "6px" : "12px",
          borderTopLeftRadius: object.order === 0 ? "25px" : undefined,
          borderBottomLeftRadius: object.order === 0 ? "25px" : undefined,
          borderTopRightRadius:
            object.order === objects.length - 1 ? "25px" : undefined,
          borderBottomRightRadius:
            object.order === objects.length - 1 ? "25px" : undefined,
          width: `${width}px`,
        }}
      >
        {small ? (
          <IgTooltip title={`${object.name}: ${object.percentage}%`}>
            <Box
              sx={{ width: `${width}px`, height: "6px" }}
              className={"test-group-name-tooltip-container"}
            ></Box>
          </IgTooltip>
        ) : null}
        {width > 20 && !small && (
          //  This is defined in App.css due to webkit props
          <Box className={"test-group-name-container"}>
            <IgTypography sx={{ maxWidth: "90%" }}>{object.name}</IgTypography>
            {showPercent && (
              <IgTypography sx={{ marginLeft: "5px" }}>
                {object.percentage}%
              </IgTypography>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
